import { StyleSheet } from 'react-native'

export default StyleSheet.create({
    headerStyle: (theme) => ({
        borderBottomWidth: 0
    }),
})
